import React from '../../vendor/react';
import { ArrowDownRight, ArrowUpRight } from '../../vendor/lucide-react';

export function MetricCard({ label, value, detail, trend }: { label: string; value: string; detail: string; trend: string }) {
  const positive = trend.startsWith('+');
  const negative = trend.startsWith('-');
  return (
    <article className="metric-card">
      <div className="metric-card__top"><span>{label}</span>{positive ? <ArrowUpRight size={17} /> : negative ? <ArrowDownRight size={17} /> : null}</div>
      <strong>{value}</strong>
      <div className="metric-card__foot"><span>{detail}</span><em className={positive ? 'positive' : negative ? 'negative' : ''}>{trend}</em></div>
    </article>
  );
}
